import React from "react";

import BrandIdentity from "../../../assets/Images/brand-identity.svg";
import LiveVideos from "../../../assets/Images/live-video.svg";
import ContentSecurity from "../../../assets/Images/content-security.svg";
import FeeCollection from "../../../assets/Images/fee-collection.svg";
import AIPoweredLeads from "../../../assets/Images/ai-leads.svg";
import SellCourses from "../../../assets/Images/sell-courses.svg";
import Results from "../../../assets/Images/results.svg";
import CircleBackground from "../../../assets/Images/SubtractTop.svg";


const FeaturesList = () => {
  return (
      <div className="featuresList">
        <img src={CircleBackground} className="featuresList_backgroundImg"/>
        <div className="featuresList_content">
          <img
            src={BrandIdentity}
            alt="circled"
            className="featuresList_content_img"
          />
          <p className="featuresList_content_head">Your Brand Identity</p>
          <p className="featuresList_content_text">
            To keep your existing brand identity intact
          </p>
        </div>

        <div className="featuresList_content">
          <img
            src={LiveVideos}
            alt="circled"
            className="featuresList_content_img"
          />
          <p className="featuresList_content_head">Live Video Lectures</p>
          <p className="featuresList_content_text">
            Switch to hybrid teaching for better reach
          </p>
        </div>

        <div className="featuresList_content">
          <img src={ContentSecurity} alt="circled" className="featuresList_content_img" />
          <p className="featuresList_content_head">Content Security</p>
          <p className="featuresList_content_text">
            Relax! Your content is secure on your app
          </p>
        </div>

        <div className="featuresList_content">
          <img src={FeeCollection} alt="circled" className="featuresList_content_img" />
          <p className="featuresList_content_head">Fee Collection</p>
          <p className="featuresList_content_text">
            Hassle-free fee payment & collection
          </p>
        </div>

      <div className="featuresList_content">
        <img
          src={AIPoweredLeads}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">AI Powered Leads</p>
        <p className="featuresList_content_text">
          Insights on who's interested in your courses
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={SellCourses}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Sell Courses</p>
        <p className="featuresList_content_text">
          Upload & sell your courses and earn 10X
        </p>
      </div>

      <div className="featuresList_content">
        <img
          src={Results}
          alt="circled"
          className="featuresList_content_img"
        />
        <p className="featuresList_content_head">Easy Assessments and Results</p>
        <p className="featuresList_content_text">
          We make it easier than never before
        </p>
      </div>

    </div>
  );
};

export default FeaturesList;
